import dayjs from 'dayjs'

const bahtFormatter = new Intl.NumberFormat('th-TH', { maximumFractionDigits: 0 })

export const formatBaht = (money) => `฿${bahtFormatter.format((money && money.value) || 0)}`

export const daysSince = (isoDateTime) => (isoDateTime ? dayjs().diff(dayjs(isoDateTime), 'day') : null)
